var map = {
	"./16x9.svg": "2c87",
	"./1x1.svg": "f3fa",
	"./2x3.svg": "b121",
	"./4x5.svg": "bc12",
	"./9x16.svg": "220d",
	"./DNA.svg": "a60a",
	"./ExpandIcon": "acdb",
	"./ExpandIcon.vue": "acdb",
	"./active-icon.svg": "2b86",
	"./ad-detail-icon.svg": "828f",
	"./add-user.svg": "2837",
	"./adset-icon.svg": "70a2",
	"./ai-book-white.svg": "566d",
	"./ai-book.svg": "b6f6",
	"./ai-gray.svg": "4ffc",
	"./ai-green.svg": "d21e",
	"./ai-script.svg": "5e50",
	"./amex-payment-icon.svg": "0a5e",
	"./animation.svg": "3c21",
	"./api-token.png": "4bc7",
	"./apple-logo-white.svg": "d52a",
	"./apple-logo.svg": "80c6",
	"./apply-filter-icon.svg": "22a0",
	"./archive-icon.svg": "74c4",
	"./archive.svg": "8238",
	"./arrow-guide.svg": "58d6",
	"./aspect-ratio-icon.svg": "b897",
	"./audio-error-image.svg": "7336",
	"./avatar-star-icon.svg": "b374",
	"./back-arrow.svg": "85f2",
	"./basic-folder-icon.svg": "9897",
	"./board-icon.svg": "c253",
	"./bolt-icon.svg": "35dd",
	"./book.svg": "fc4e",
	"./box-click.svg": "c603",
	"./brand-profile.svg": "a562",
	"./briefs.png": "8f4d",
	"./brush-icon.png": "dd6d",
	"./brush.svg": "3f92",
	"./calendar.svg": "b8bd",
	"./cancel-card.svg": "955f",
	"./carousel.svg": "2246",
	"./chain.svg": "ca9a",
	"./checked-checkbox.svg": "1afb",
	"./chevron-down-small.svg": "1d15",
	"./chevron-grabber-vertical.svg": "1e6e",
	"./chevron-right-small.svg": "1a14",
	"./chevron-top-small.svg": "3118",
	"./circle-checkmark-confirm.svg": "1ec9",
	"./clipboard-icon.svg": "1abd",
	"./clock-icon.svg": "e315",
	"./clock2.svg": "7ebd",
	"./close.svg": "8b1b",
	"./cloud upload.svg": "d3db",
	"./cloud-file.svg": "70ff",
	"./collapse.svg": "dbb3",
	"./commercial.svg": "5dae",
	"./community-icon.svg": "02b7",
	"./copy.svg": "8aac",
	"./create-board-icon.svg": "478a",
	"./create-folder-icon.svg": "a5a5",
	"./create-spyder-icon.svg": "b419",
	"./creative-tests.svg": "7392",
	"./default-avatar.png": "3227",
	"./description-icon.svg": "411a",
	"./discovery.png": "bcc6",
	"./document-gray.svg": "f73b",
	"./document.svg": "4aa0",
	"./dots.svg": "93d2",
	"./download.svg": "f28e",
	"./drag.svg": "88c6",
	"./drag1.svg": "66c8",
	"./edit-icon.svg": "f4c4",
	"./editorial.svg": "3ec8",
	"./expand.svg": "8336",
	"./export-csv.svg": "394c",
	"./external-tab.svg": "9002",
	"./exthumbnail.svg": "522e",
	"./file-chain.svg": "9635",
	"./file.svg": "a147",
	"./flag.svg": "c26e",
	"./folder.svg": "383d",
	"./font.svg": "b8a2",
	"./foreplay-api-icon.svg": "5638",
	"./foreplay-gray.svg": "f9ba",
	"./gantt-bar-live.png": "fc92",
	"./gif.svg": "9517",
	"./gift-icon.svg": "e207",
	"./globe.svg": "0de3",
	"./google-play-logo.svg": "5aa4",
	"./green-link-arrow-icon.svg": "c688",
	"./heart-icon.svg": "267f",
	"./heart.svg": "7d16",
	"./help-icon.svg": "7975",
	"./ig-verify-1.svg": "c3c1",
	"./ig-verify-2.svg": "db2d",
	"./image-icon.svg": "684d",
	"./image.svg": "931c",
	"./information-fill.svg": "5b60",
	"./information-icon.svg": "c971",
	"./inspiration-bg.png": "bf9b",
	"./landscape-icon.svg": "8890",
	"./layers-copy.svg": "c474",
	"./layout-icon.svg": "82cd",
	"./lens-orb-small.png": "bb98",
	"./lens.png": "9075",
	"./lensIcon.png": "de83",
	"./library-create-icon.svg": "147b",
	"./line.svg": "aa4c",
	"./link-document.svg": "ded5",
	"./link.svg": "40a1",
	"./link2.svg": "d8ae",
	"./loader.svg": "04ff",
	"./locked-dark.svg": "63c5",
	"./locked.svg": "855c",
	"./loom.svg": "4ba6",
	"./magic-stick-top-white.svg": "dd09",
	"./magic-stick-top.svg": "5bda",
	"./mailers/gmail.png": "5374",
	"./mailers/icloud.png": "9623",
	"./mailers/outlook.png": "8bf2",
	"./mailers/proton.png": "c574",
	"./mailers/yahoo.png": "7439",
	"./mcp-platforms/chatgpt.svg": "80e6",
	"./mcp-platforms/claude.svg": "e7fd",
	"./mcp-platforms/gemini.svg": "5c65",
	"./mcp-platforms/grok.svg": "1ae1",
	"./megaphone.svg": "a475",
	"./move-board-icon.svg": "dd70",
	"./my-ads-icon.svg": "740a",
	"./nav-brush-icon.svg": "4cb1",
	"./nav-layout-icon.svg": "135b",
	"./nav-video-script-icon.svg": "3e2e",
	"./new-board-icon.svg": "f8ce",
	"./new-check.svg": "3712",
	"./new-folder-icon.svg": "1cef",
	"./new-un-pin.svg": "310d",
	"./note.svg": "f079",
	"./notifications-icon.svg": "d300",
	"./odometer.svg": "67b0",
	"./paypal-icon.svg": "5f4d",
	"./pencil.svg": "e51f",
	"./pinned-cancel.svg": "4ae9",
	"./pinned.svg": "a01b",
	"./plant-icon.svg": "da91",
	"./play-btn.svg": "7fd1",
	"./play-icon.svg": "5233",
	"./plus-circle.svg": "d99e",
	"./plus-icon-white.svg": "5bba",
	"./plus-icon.svg": "0a7c",
	"./powered-by-stripe.svg": "0653",
	"./preview-icon.svg": "6c61",
	"./questionmark.svg": "a413",
	"./scrub.svg": "9f9e",
	"./search-page-find.svg": "6d81",
	"./search-white.svg": "1d41",
	"./search.svg": "d103",
	"./send-message-gray.svg": "ac7f",
	"./settings-icon.svg": "36e8",
	"./share.svg": "bd5b",
	"./sign-in-redirect.svg": "e51e",
	"./size.svg": "b18f",
	"./smaller-aspect-ratio-icon.svg": "cfe3",
	"./smiley.svg": "8496",
	"./sort.svg": "f931",
	"./source-script.svg": "38bb",
	"./speaker.svg": "5989",
	"./spyder-icon.svg": "78d0",
	"./spyder-token-disabled.png": "3e3d",
	"./spyder-token.png": "f2f9",
	"./spyder.png": "d883",
	"./star-wand-icon.svg": "cb32",
	"./stars-icon.svg": "08cf",
	"./studio.svg": "850d",
	"./support.svg": "33f5",
	"./swipe-file.png": "5d03",
	"./template.svg": "909f",
	"./text-size.svg": "4157",
	"./trash-gray.svg": "2916",
	"./trash-icon.svg": "428fe",
	"./trash.svg": "af22",
	"./tutorial.svg": "9bc3",
	"./typography-icon.svg": "92f8",
	"./uaa-logo.png": "9621",
	"./ugc.svg": "746e",
	"./unarchive.svg": "3daa",
	"./unchecked-checkbox.svg": "fb21",
	"./unpinned.svg": "926c",
	"./upload-icon.svg": "4052",
	"./video clapperboard.svg": "4384",
	"./video-icon.svg": "2da3",
	"./video-iconsvg.svg": "b2b9",
	"./video-script-icon.svg": "57b5",
	"./video.svg": "512b1",
	"./voice-icon.svg": "7bc9d",
	"./wand.svg": "3083",
	"./warning-icon.svg": "209f",
	"./warning.svg": "daa9",
	"./winner.svg": "ae23",
	"./x-button.svg": "4099"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";